import React from 'react'

const ScreenCover = ({isOpen, onClick, top = 'top-0', left = 'left-0'}) => {
	return (
		<React.Fragment>
			{isOpen && (
				<div 
					className={`fixed ${top} ${left} w-screen h-screen bg-black/50 z-0`}
					onClick={onClick}
				/>
			)}
		</React.Fragment>
	)
}

export default ScreenCover